/**
 * Get the device id
 * @returns {string}
 */
export const getDeviceId = async () => {
  try {
    return window.oipfObjectFactory.createConfigurationObject().localSystem.deviceID || '';
  } catch (error) {
    return '';
  }
};

/**
 * Get the device OS version
 * @returns {string}
 */
export const getVersion = async () => {
  try {
    return window.oipfObjectFactory.createConfigurationObject().localSystem.softwareVersion || '';
  } catch (error) {
    return '';
  }
};

/**
 * Get the device model name
 * @returns {string}
 */
export const getModel = async () => {
  try {
    return window.oipfObjectFactory.createConfigurationObject().localSystem.modelName || '';
  } catch (error) {
    return '';
  }
};

/**
 * Get the device brand name
 * @returns {string}
 */
export const getBrand = async () => 'vodafone';

/**
 * Get the device type
 * @return {String} Return the device type, empty string if undetectable or not implemented
 */
export const getDeviceType = async () => '';

/**
 * Return the device model code
 * @return {String} Return the device model code, empty string if undetectable or not implemented
 */
export const getModelCode = async () => '';
